import { Option } from '../components/commons/OptionList/OptionList';
import {

  BlockchainTypes,
  ContractEnvironment,
} from '@mentaport/supplement';
import { LocalIcons } from '../assets/icons/icons';

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
export const regenerateOptionsWithCustomNewValue = (
  options: Option[],
  value: any
): Option[] => {
  const tempOptions = [...options];
  const index = tempOptions.findIndex(x => x?.isSelected === true);
  if (tempOptions[index]) {
    tempOptions[index].value = value;
  }
  return tempOptions;
};

export const regenerateOptionsWithNewValue = (
  newValue: any,
  defaultOptions: Option[]
): Option[] => {
  const tempOptions = [...defaultOptions];
  tempOptions.forEach(element => {
    element.isSelected = false;
  });
  const index = tempOptions.findIndex(x => x?.value === newValue);
  if (tempOptions[index]) {
    tempOptions[index].isSelected = true;
  } else {
    const customIndex = tempOptions.findIndex(x => x?.isCustom === true);
    tempOptions[customIndex].isSelected = true;
  }
  return tempOptions;
};

export const getDefaultContractEnvironmentOptions = (
  isMezzanine: boolean
): Option[] => [
  {
    id: 1,
    label: capitalizeFirstLetter(ContractEnvironment.Testnet),
    value: ContractEnvironment.Testnet,
    isSelected: !isMezzanine,
  },
  {
    id: 2,
    label: capitalizeFirstLetter(ContractEnvironment.Mainnet),
    value: ContractEnvironment.Mainnet,
  },
  {
    id: 3,
    label: capitalizeFirstLetter(ContractEnvironment.Mezzanine),
    value: ContractEnvironment.Mezzanine,
    isSelected: isMezzanine,
  },
  // {
  //   id: 4,
  //   label: 'Localhost',
  //   value: ContractEnvironment.Localhost,
  // },
];

export const getDefaultBlockchainTypeOptions = (
  isMezzanine: boolean
): Option[] => [
  {
    id: 1,
    label: capitalizeFirstLetter(BlockchainTypes.Base),
    value: BlockchainTypes.Base,
    icon: LocalIcons.BaseLogo,
    isSelected: true,
  },
  {
    id: 2,
    label: capitalizeFirstLetter(BlockchainTypes.Polygon),
    value: BlockchainTypes.Polygon,
    icon: LocalIcons.PolygonLogo,
    isSelected: false,
  },
  {
    id: 3,
    label: capitalizeFirstLetter(BlockchainTypes.Monad),
    value: BlockchainTypes.Monad,
    icon: LocalIcons.MonadLogo,
  },
  {
    id: 4,
    label: capitalizeFirstLetter(BlockchainTypes.Soneium),
    value: BlockchainTypes.Soneium,
    icon: LocalIcons.SoneiumLogo,
  },
  // {
  //   id: 2,
  //   label: 'Sui',
  //   value: BlockchainTypes.Sui,
  //   icon: LocalIcons.SuiLogo,
  // },
  // {
  //   id: 3,
  //   label: 'Ethereum',
  //   value: BlockchainTypes.Ethereum,
  //   icon: LocalIcons.EthereumLogo,
  // },
];
